<template>
    <footer class="footer">
        {{ $t("business.footer") }}
    </footer>
</template>

<style scoped>
.footer {
    margin-top: 100px;
    padding: 50px 0;
    text-align: center;

    font-size: 20px;
    color: #373737;
}

@media screen {
    .footer {
        margin-top: 50px;
    }
}
</style>